import styled from "styled-components/macro";
import { CheckButton, Text } from "@ds/react";

export const ToggleButtonContainer = styled.div(({ half, theme }) => ({
  width: "100%",

  [theme.breakpoint.lg()]: {
    maxWidth: half && "50%",
    minWidth: "300px",
  },
}));

export const Title = styled(Text)(({ theme: { spacing, color } }) => ({
  color: color.neutral["02"],
  marginBottom: spacing.stack["3xs"],
}));

export const SingleOption = styled.div(
  ({ theme: { color, border, breakpoint }, half, error }) => ({
    display: "flex",
    border: `1px solid ${error ? color.feedback.error : color.neutral["06"]}`,
    borderRadius: border.radius["2xs"],

    width: "100%",

    [breakpoint.lg()]: {
      maxWidth: half && "50%",
      minWidth: "300px",
    },
  })
);

export const ToggleButton = styled(CheckButton)(
  ({ value, theme: { breakpoint, color, border } }) => ({
    borderColor: value ? color.brandPrimary.light : "transparent",
    cursor: "pointer",
    zIndex: value ? 1 : 0,
    borderRadius: border.radius["2xs"],

    "&:hover": {
      backgroundColor: value ? color.brandPrimary.light : color.neutral["08"],

      "span:last-child": {
        color: value ? color.neutral["08"] : color.brandPrimary.light,
      },
    },

    "&:not(:first-child)": {
      marginLeft: "-36px",
    },

    "> div": {
      display: "none",
    },

    [breakpoint.xs()]: {
      padding: "12px 0",
      "&:not(:first-child)": {
        marginLeft: "-12px",
      },
    },
  })
);

export const SectionError = styled.div(({ theme: { spacing } }) => ({
  display: "flex",
  marginTop: spacing.stack["3xs"],
}));

export const ErrorMsg = styled(Text)(({ theme: { color } }) => ({
  color: color.feedback.error,
}));
